import { render, staticRenderFns } from "./resourceCenter_detail.vue?vue&type=template&id=67a15036&scoped=true&"
import script from "./resourceCenter_detail.vue?vue&type=script&lang=js&"
export * from "./resourceCenter_detail.vue?vue&type=script&lang=js&"
import style0 from "./resourceCenter_detail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./resourceCenter_detail.vue?vue&type=style&index=1&id=67a15036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a15036",
  null
  
)

export default component.exports